import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {RolePO} from "@/model/system";
import {PaybackPO} from "@/model/finance";
import {ContractPO} from "@/model/customer";

export enum RoleEnum {
    GetRoleTree = "/role/getRoleTree",
    GetRole = "/role/getRole",
    CreateRole = "/role/createRole",
    UpdateRole = "/role/updateRole",
}

export interface RoleTreeBO {
}

export interface RoleTreeVO extends RolePO {
}

export interface RoleVO extends RolePO {
    paybacks: PaybackPO[];
    contract: ContractPO
    contact: string
    mobile: string;
}

export interface ReceiveRoleBO {
    instanceId: number;
    businessId: number;
    executeId: string;
}

export const useQueryRoleTree = () => useQuery({
    queryKey: ["queryRoleTree"],
    queryFn: (data: RoleTreeBO) => http.get<BaseVO<RoleTreeVO[]>>({
        url: RoleEnum.GetRoleTree,
        data,
    }),
})

export const useCreateRole = () => useMutation({
    mutationFn: (data: any) => http.put<BaseVO<null>>({
        url: RoleEnum.CreateRole,
        data
    }),
})

export const useUpdateRole = () => useMutation({
    mutationFn: (data: any) => http.post<BaseVO<null>>({
        url: RoleEnum.UpdateRole,
        data
    }),
})

export const useQueryRole = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<RoleVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<RoleVO>>({
        url: RoleEnum.GetRole,
        params: params
    }),
    enabled
})


